<template>
  <b-container id="main-container" fluid style>
    <b-row style="width:100%; background-color:#E8E8EA" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width:100%; margin-top:60px;" class="abouthero" align-h="center">
      
    </b-row>

    <b-row style="width:100%; margin-top:80px; padding-bottom:60px" align-h="center" class='ourstory'>
      
      <b-col cols="12" style="max-width:1440px">
        <p  class="aboutmaintext" style='font-size:34px;'>Our Story</p>
        <p  class="aboutmaintext">Truthbrush was founded by concerned parents who see a world where sugary foods are almost impossible to avoid, video games and mobile phone usage are all consuming, and anxiety and depression are pervasive among kids. Our goal is to introduce innovative solutions that promote healthy living and alleviate the enormous burden on parents who struggle to balance their child’s health needs with the realities of the world around them.</p>
        <br>
        <p  class="aboutmaintext">Our initial focus is on the prevention of tooth decay and periodontal disease. Your mouth is the gateway to your health and a bright smile builds confidence and good feelings of self worth. Tooth decay is one of the most unmet healthcare needs in children and adolescents and can lead to a variety of life problems including the increased risk of heart disease, diabetes, pneumonia and other serious medical conditions.</p>
        <br>
        <p class="aboutmaintext">We built the Truthbrush&trade; because we truly believe in the saying that an ounce of prevention is worth a pound of cure. Its simple design allows parents and dentists to monitor, reward and coach kids to form better brushing habits which is a big step towards a healthy and happy life. It is our desire to build low cost products that are accessible to as many families as possible.</p>
        <br>
        <p class="aboutmaintext">Our founders are technologists with expertise in low cost connected devices. After years developing products for mobile phone makers and payment systems, we are thrilled to focus our energy and experience on solving problems that can improve the quality of life. </p>
        
        <br><br>
        <p class="aboutmaintext">Dr. Eric Huang</p>
        <p class="aboutmaintext">
          Chief Executive Officer
        </p>
      </b-col>
    </b-row>

    <b-row style="width:100%;">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter
  }
};
</script>

<style lang="scss">
.abouthero {
  background-color: black;
}

@media (max-width: 575px) {
  .abouthero {
    background-image: url(/img/group-2@2x-min.jpg);
    background-position: 30% center ;
    background-repeat: no-repeat;
    margin-bottom: 0px !important;
    background-size: cover;
    min-height: calc(100vh - 60px);
  }
}

@media (max-width: 1199px) {


  .aboutherotext {
    color: white;
    font-size: 30px;
    padding-top: 50px;
    padding-left: calc(50% - 600px)!important;
    padding-right: calc(50% - 600px)!important;
    text-align: left;
  }

  .aboutmaintext {
    color: black;
    font-size: 20px;
    padding-left:5%;
    padding-right:5%;
  }

  .ourstory>.col-12{
    padding-left:0;
    padding-right:0;
    .aboutmaintext{
      text-align:center;
    }
  }

}


  .abouthero {
    background-image: url(/img/group-2@2x-min.jpg);
    background-position: 62% center;
    background-repeat: no-repeat;
    margin-bottom: 0px !important;
    background-size: cover;
    min-height: 400px;
  }

@media (min-width: 1200px) {

  .aboutherotext {
    color: white;
    font-size: 46px;
    max-width: 850px;
    padding-top: 70px;
    padding-left: calc(50% - 600px + 15px)!important;
    padding-right: calc(50% - 600px  + 15px)!important;
    text-align: left;
  }

  .aboutmaintext {
    color: black;
    font-size: 24px;
    padding-left:15%;
    padding-right:15%;
  }
}
</style>